module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm2_press.081ebf49.png";